module.exports = "/images/_/_/_/_/api.acadevian.com/resources/js/src/assets/images/banner/banner-39.jpg";